export const AUTH_STORAGE_KEYS = {
  accessToken: "okta_access_token",
  idToken: "okta_id_token",
  tokenExpiresAt: "okta_token_expires_at",
  user: "okta_user",
  /** JSON snapshot of `effective_access` from last successful /auth/okta/verify. */
  effectiveAccess: "okta_effective_access",
  /** Catalog-matched groups from last successful /auth/okta/verify (`matched_groups`). */
  matchedGroups: "okta_matched_groups",
} as const;

